//JS Imports
import { windowIsSmallerThan, toggleDarkMode } from './helpers'
import Lenis from 'lenis'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

//Lenis
const lenis = new Lenis({
    duration: 1.3,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

//Start raf loop    
requestAnimationFrame(raf)

// The 2026 menu uses its own accessible controls instead of GeneratePress toggles.
window.addEventListener('roam:navigation-toggle', (event) => {
  if (event.detail.open) lenis.stop();
  else lenis.start();
});

jQuery(document).ready(function ($) { 
  
  // Add Lenis Prevent to Mobile Menu
  $(document).on('click', '#mobile-menu-control-wrapper .menu-toggle', function() {
    if ( $('.mobile-menu-open').length > 0 ) {
      lenis.stop();
      $('#site-navigation').attr("data-lenis-prevent", "true");
    } else {
      lenis.start();
      $('#site-navigation').removeAttr("data-lenis-prevent");
    }
  });

})
